import { Hero } from "../../components/Hero";
import { Clases } from "../../components/Clases";
import { Precios } from "../../components/Precios";
import { Testimonios } from "../../components/Testimonios";
import { Contacto } from "../../components/Contacto";
import { Footer } from "../../components/Footer";


export function ClasesPage() {
  return (
    <main>
      <Hero />
      <Clases />
      <Precios />
      <Testimonios />
      <Contacto />
      <Footer />
    </main>
  )
}